export function useMembershipLevels() {
    onMounted(async () => {
        if (!supplierStore.membershipLevels?.length) await load()
    })

    const load = async () => {
        await supplierStore.loadMembershipLevels()
    }

    const membershipLevels = computed(() => supplierStore.membershipLevels)

    return {membershipLevels}
}
